/*
  eslint
  react/no-array-index-key: off
*/
import React, { PropTypes, PureComponent } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import cn from 'classnames';
import {
  Backspace, Button, Container, SystemMessages,
} from '../../shared';
import statsd from '../../../lib/StatsD';
import { setCurrentUser } from '../../../store/currentUser/actions';
import Digit from './digit';
import styles from './styles.scss';
import messages from './i18n';
import Keypadbutton from './keypadbutton';

function getValidClass(status) {
  switch (status) {
    case 'invalid':
      return 'incorrect';
    case 'valid':
      return 'correct';
    case 'pending':
    default:
      return '';
  }
}

export class Keypad extends PureComponent {
  static propTypes = {
    setCurrentUser: PropTypes.func,
    clearAdminPasscode: PropTypes.func,
    systemMessages: PropTypes.array,
    settings: PropTypes.object,
    activeButton: PropTypes.string,
    isFirstTimeClockIn: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.addDigit = this.addDigit.bind(this);
    this.delDigit = this.delDigit.bind(this);
    this.clearDigits = this.clearDigits.bind(this);
    this.showPasscode = this.showPasscode.bind(this);
    this.handleKeypress = this.handleKeypress.bind(this);

    this.state = {
      passcode: '',
      passcodeStatus: 'pending',
    };
  }

  componentWillMount() {
    this.setState({ activeButton: '' });

    this.modifyDigits('');
    document.addEventListener('keydown', this.handleKeypress);
    if (window.NATIVE_INTERCOM) {
      window.intercom.logEvent('arrived_at_keypad');
    } else if (window.Intercom) {
      window.Intercom('trackEvent', 'arrived_at_keypad'); // eslint-disable-line
    }

    if (!localStorage.getItem('platform_tracked')) {
      const platform = window.platform || (window.device && window.device.platform) || 'web';
      statsd.increment(`time-clock-platform-${platform}`);

      localStorage.setItem('platform_tracked', true);
    }
  }

  componentDidMount() {
    // give them 8 seconds to finish entering their passcode
    this.resetTimer();
  }

  componentWillUnmount() {
    this.props.clearAdminPasscode();
    document.removeEventListener('keydown', this.handleKeypress);
  }

  resetTimer() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.clearDigits();
    }, 8000);
  }

  handleKeypress(e) {
    const num = parseInt(e.key, 10);
    if (!Number.isNaN(num)) {
      e.preventDefault();
      return this.addDigit(num);
    }
    if (((e.ctrlKey || e.metaKey) && e.key === 'Backspace') || e.key === 'Escape') {
      e.preventDefault();
      return this.clearDigits();
    }
    if (e.key === 'Backspace') {
      e.preventDefault();
      return this.delDigit();
    }
    return null;
  }


  modifyDigits(newPasscode, cb = () => {}) {
    if (this.state.passcodeStatus !== 'pending') {
      // don't allow any button presses until the status is reset correctly
      return;
    }
    const { length } = this.props.settings.pinDetails;
    this.setState({ passcode: newPasscode.toString().trim().padEnd(length) }, () => {
      this.resetTimer();
      cb();
    });
  }

  addDigit(value) {
    this.modifyDigits(`${this.state.passcode.trim()}${value}`, () => {
      const { showNext, length } = this.props.settings.pinDetails;
      const trimmed = this.state.passcode.trim();
      if (showNext && trimmed.length < length) {
        // we don't need to handle this case because they have to press next
        return;
      }
      if (trimmed.length !== length) {
        // don't need to check if we haven't entered all the numbers yet
        return;
      }
      // check the passcode
      this.checkIfValidPasscode();
    });
  }

  delDigit() {
    this.modifyDigits(this.state.passcode.trim().slice(0, -1));
  }

  clearDigits() {
    this.modifyDigits('');
  }

  checkIfValidPasscode() {
    const { length } = this.props.settings.pinDetails;
    const trimmed = this.state.passcode.trim();
    const employee = this.props.employees.find(e => e.passcode === trimmed);
    if (!employee) {
      // invalid
      return this.setState({ passcodeStatus: 'invalid' }, () => {
        setTimeout(() => {
          this.setState({
            passcodeStatus: 'pending',
            passcode: ''.padEnd(length),
          });
        }, 250);
      });
    }
    return this.setState({ passcodeStatus: 'valid' }, () => {
      setTimeout(() => {
        this.props.setCurrentUser(employee.id);
        this.setState({
          passcodeStatus: 'pending',
          passcode: ''.padEnd(length),
        });
      }, 250);
    });
  }

  showPasscode() {
    const { passcode } = this.state;
    const { length } = this.props.settings.pinDetails;
    const validClass = getValidClass(this.state.passcodeStatus);
    const defaultPin = ''.padEnd(length);
    const headerText = this.props.isFirstTimeClockIn()
      ? this.props.intl.formatMessage(messages.passcodeHint)
      : this.props.intl.formatMessage(messages.passcode);


    // construct digit elements
    const digits = (passcode || defaultPin).split('').map((digit, i) => {
      const enteredClass = digit !== ' ' ? 'entered' : null;
      return (
        <Digit className={cn(validClass, enteredClass)} key={i}>
          <p className={cn(enteredClass)}>{digit}</p>
        </Digit>
      );
    });
    // conditionally construct placeholder
    const placeholder = (passcode || '').replace(/ /g, '').length === 0 ?
      <h2>{headerText}</h2> : null;

    // return passcode object
    return (
      <div className='placeholder'>
        {placeholder}
        <div className='digitBox'>{digits}</div>
      </div>
    );
  }

  showSystemMessages() {
    if (this.props.systemMessages.length < 1) {
      return null;
    }
    return (
      <SystemMessages
        messages={this.props.systemMessages}
      />
    );
  }

  renderNext() {
    return this.props.settings.pinDetails.showNext ?
      <div className='login'>
        <Button className='blue' onClick={() => this.checkIfValidPasscode(true/* force check */)}>
          <p>Next <i className="fa fa-chevron-right" /></p>
        </Button>
      </div>
      : null;
  }

  render() {
    return (
      <div className='newkeypad'>
        <Container>
          <div className='passcode'>
            {this.showPasscode()}
          </div>

          <div className='numpad'>
            <div className='keyrow'>
              <Keypadbutton
                number="1"
                isActive={this.state.activeButton === '1'}
                addDigit={this.addDigit}
              />
              <Keypadbutton
                number="2"
                isActive={this.state.activeButton === '2'}
                addDigit={this.addDigit}
              />
              <Keypadbutton
                number="3"
                isActive={this.state.activeButton === '3'}
                addDigit={this.addDigit}
              />
            </div>
            <div className='keyrow'>
              <Keypadbutton
                number="4"
                className={this.props.isFirstTimeClockIn() && this.state.pulse ? styles.pulsate : ''}
                isActive={this.state.activeButton === '4'}
                addDigit={this.addDigit}
              />
              <Keypadbutton
                number="5"
                isActive={this.state.activeButton === '5'}
                addDigit={this.addDigit}
              />
              <Keypadbutton
                number="6"
                isActive={this.state.activeButton === '6'}
                addDigit={this.addDigit}
              />
            </div>
            <div className='keyrow'>
              <Keypadbutton
                number="7"
                isActive={this.state.activeButton === '7'}
                addDigit={this.addDigit}
              />
              <Keypadbutton
                number="8"
                isActive={this.state.activeButton === '8'}
                addDigit={this.addDigit}
              />
              <Keypadbutton
                number="9"
                isActive={this.state.activeButton === '9'}
                addDigit={this.addDigit}
              />
            </div>
            <div className='keyrow'>
              <Button className='key clear' onClick={() => this.clearDigits()}>
                <p>CLEAR</p>
              </Button>
              <Keypadbutton
                number="0"
                isActive={this.state.activeButton === '0'}
                addDigit={this.addDigit}
              />
              <Button className='key clear' onClick={() => this.delDigit()}>
                <Backspace />
              </Button>
            </div>
          </div>
          {this.renderNext()}
        </Container>

        {this.showSystemMessages()}
      </div>
    );
  }
}

export default injectIntl(connect(state => ({ employees: state.get('employees').toJSON() }), { setCurrentUser })(Keypad));



// WEBPACK FOOTER //
// ./src/components/timeclock/keypad/index.jsx